import axios from "axios";
import { getCookies } from "../../utils/getToken";
import { NotificationManager } from "react-notifications";
import {
  errorResponse,
  validateApiData
} from "../../utils/validators/validators";
import {SERVER_URL} from "../../utils/config/constants"
export const ProviderRevenueList = async params => {
    return new Promise(async(resolve, reject) => {
        var authToken = getCookies();
        try {
          const { data } = await axios({
            method: "get",
            url: `${SERVER_URL}/provider/revenue`,
            params: params,
            headers: { "x-auth-token": authToken }
          });
      
          return validateApiData(data) ? resolve(data) : reject(errorResponse);
        } catch (e) {
          NotificationManager.error(e.message, "Oops!");
          return reject (e);
        }
    })
    
  };


// WEBPACK FOOTER //
// ./src/apiHelpers/revenue/list.js